export const bibleVerses = {
  en: {
    john_3_16: {
      text: 'For God so loved the world that he gave his one and only Son, that whoever believes in him shall not perish but have eternal life.',
      reference: 'John 3:16'
    },
    acts_17_11: {
      text: 'These people were more receptive than those in Thessalonica. They were very willing to receive the message, and every day they carefully examined the Scriptures to see if those things were so.',
      reference: 'Acts 17:11'
    }
  },
  
  es: {
    john_3_16: {
      text: 'Porque de tal manera amó Dios al mundo, que ha dado a su Hijo unigénito, para que todo aquel que en él cree, no se pierda, mas tenga vida eterna.',
      reference: 'Juan 3:16'
    },
    acts_17_11: {
      text: 'Estos eran más nobles que los que estaban en Tesalónica, pues recibieron la palabra con toda solicitud, escudriñando cada día las Escrituras para ver si estas cosas eran así.',
      reference: 'Hechos 17:11'
    }
  },
  
  fr: {
    john_3_16: {
      text: 'Car Dieu a tant aimé le monde qu\'il a donné son Fils unique, afin que quiconque croit en lui ne périsse point, mais qu\'il ait la vie éternelle.',
      reference: 'Jean 3:16'
    },
    acts_17_11: {
      text: 'Ces Juifs avaient des sentiments plus nobles que ceux de Thessalonique; ils reçurent la parole avec beaucoup d\'empressement, et ils examinaient chaque jour les Écritures, pour voir si ce qu\'on leur disait était exact.',
      reference: 'Actes 17:11'
    }
  },
  
  de: {
    john_3_16: {
      text: 'Denn also hat Gott die Welt geliebt, dass er seinen eingeborenen Sohn gab, damit alle, die an ihn glauben, nicht verloren werden, sondern das ewige Leben haben.',
      reference: 'Johannes 3:16'
    },
    acts_17_11: {
      text: 'Diese aber waren freundlicher als die in Thessalonich; sie nahmen das Wort bereitwillig auf und forschten täglich in der Schrift, ob sich\'s so verhielte.',
      reference: 'Apostelgeschichte 17:11'
    }
  },
  
  pt: {
    john_3_16: {
      text: 'Porque Deus amou o mundo de tal maneira que deu o seu Filho unigênito, para que todo aquele que nele crê não pereça, mas tenha a vida eterna.',
      reference: 'João 3:16'
    },
    acts_17_11: {
      text: 'Ora, estes foram mais nobres do que os que estavam em Tessalônica, porque de bom grado receberam a palavra, examinando cada dia nas Escrituras se estas coisas eram assim.',
      reference: 'Atos 17:11'
    }
  },
  
  ru: {
    john_3_16: {
      text: 'Ибо так возлюбил Бог мир, что отдал Сына Своего Единородного, дабы всякий верующий в Него, не погиб, но имел жизнь вечную.',
      reference: 'Иоанна 3:16'
    },
    acts_17_11: {
      text: 'Здешние были благомысленнее Фессалоникских: они приняли слово со всем усердием, ежедневно разбирая Писания, точно ли это так.',
      reference: 'Деяния 17:11'
    }
  },
  
  tl: {
    john_3_16: {
      text: 'Sapagkat gayon na lamang ang pag-ibig ng Diyos sa sanglibutan, na ibinigay niya ang kanyang bugtong na Anak, upang ang sinumang sumasampalataya sa kanya ay hindi mapahamak, kundi magkaroon ng buhay na walang hanggan.',
      reference: 'Juan 3:16'
    },
    acts_17_11: {
      text: 'Ang mga tao rito ay mas bukas pa sa salita kaysa sa mga taga-Tesalonica. Tinanggap nila ang mensahe nang buong sigasig at araw-araw nilang sinisiyasat ang mga Kasulatan upang malaman kung totoo nga ang mga bagay na iyon.',
      reference: 'Mga Gawa 17:11'
    }
  },
  
  it: {
    john_3_16: {
      text: 'Perché Dio ha tanto amato il mondo, che ha dato il suo unigenito Figlio, affinché chiunque crede in lui non perisca, ma abbia vita eterna.',
      reference: 'Giovanni 3:16'
    },
    acts_17_11: {
      text: 'Or questi erano di sentimenti più nobili di quelli di Tessalonica, perché ricevettero la parola con ogni premura, esaminando ogni giorno le Scritture per vedere se queste cose stavano così.',
      reference: 'Atti 17:11'
    }
  },
  
  am: {
    john_3_16: {
      text: 'እግዚአብሔር ዓለምን እጅግ በጣም ስለወደዳት ወንድ ልጁን ሰጠች፣ በእርሱ የሚያምነው ሁሉ እንዳይጠፋ ነገር ግን የዘላለም ሕይወት እንዲኖረው።',
      reference: 'ዮሐንስ ወንጌል 3:16'
    },
    acts_17_11: {
      text: 'እነዚህም ከተሰሎንቄ ያሉት የበለጠ ክቡራን ነበሩ፤ ቃሉን በደስታ ተቀብለው እነዚህ ነገሮች እንዲህ ይሆን እንደሆነ ለማወቅ በየቀኑ መጻሕፍተ ቅዱሳትን ይመረምሩ ነበር።',
      reference: 'ሐዋርያት ሥራ 17:11'
    }
  },
  
  ko: {
    john_3_16: {
      text: '하나님이 세상을 이처럼 사랑하사 독생자를 주셨으니 이는 그를 믿는 자마다 멸망하지 않고 영생을 얻게 하려 하심이라',
      reference: '요한복음 3:16'
    },
    acts_17_11: {
      text: '베뢰아에 있는 사람들은 데살로니가에 있는 사람들보다 더 너그러워서 간절한 마음으로 말씀을 받고 이것들이 그러한가 하여 날마다 성경을 상고하므로',
      reference: '사도행전 17:11'
    }
  },
};